<template>
    <div class="m-searchbar searchbar">
        <div class="searchbar__inner-container">
            <svg-icon
                v-if="icon && icon === 'left'"
                original
                name="icons/search-red"
                class="searchbar__icon searchbar__icon--left"
            />
            <AInput
                :placeholder="$t('m-searchbar_placeholder')"
                clearable
                :value="localValue"
                :id="'search-input'"
                @onFocus="handleFocus"
                @onBlur="handleBlur"
                @onChange="handleInput"
                @onClear="handleClear"
            />
            <svg-icon
                v-if="icon && icon === 'right' && !localValue"
                original
                name="icons/search-red"
                class="searchbar__icon searchbar__icon--right"
            />
        </div>
    </div>
</template>

<script>
import AInput from '../../atoms/a-input/a-input';

export default {
    name: 'MSearchbar',
    components: {
        AInput
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);  
            }
        }
    },
    methods: {
        handleInput(val) {
            this.localValue = val;
        },
        handleFocus() {
            this.$emit('onFocus', true);
        },
        handleBlur() {
            this.$emit('onBlur', false);
        },
        handleClear() {
            this.$emit('onClear');
        }
    }
} 
</script>

<style lang="scss">
@import "m-searchbar";   
</style>